<template>
  <div class="app-warpper">
    <div class="header">
      <!-- 左侧大标题 -->
      <div class="bigtitle">
        <div class="logo"></div>
        余姚市山洪四预应用
      </div>

      <!-- 导航栏 -->
      <nar-bar></nar-bar>

      <!-- 右侧用户部分 -->
      <div class="right">
        &nbsp;&nbsp;
        <div class="shanhonglianfang">
          <a href="/">四预首页 </a>
        </div>
        <div class="line"></div>
        <div class="user">
          <div class="pic"></div>
          <div class="name">
            <el-dropdown trigger="click" @command="handleClickItem">
              <span class="el-dropdown-link"> {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">修改密码</el-dropdown-item>
                <el-dropdown-item :command="2">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="main-container">
      <sider-bar class="siderbar" v-if="!(URL === `publicWarning`)"></sider-bar>
      <app-main class="appMain"></app-main>
    </div>

    <el-dialog title="密码修改" :visible.sync="dialogVisible" top="9vh" width="30%" @close="resetForm">
      <div class="note">注：密码要求：8-20位，包含数字、小写字母、大写或特殊字符</div>
      <section>
        <el-form :model="form" :rules="rules" status-icon ref="passwordForm" label-width="80px">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input v-model="form.oldPassword" autocomplete="off" style="width: 90%"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="form.password" autocomplete="off" style="width: 90%"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPassword">
            <el-input type="password" v-model="form.checkPassword" autocomplete="off" style="width: 90%"></el-input>
          </el-form-item>
        </el-form>
      </section>
      <div class="footer">
        <div class="footer-button">
          <el-button class="submit" icon="el-icon-check" type="primary" @click="submitForm">确定</el-button>
          <el-button class="submit" icon="el-icon-refresh-right" type="primary" @click="resetForm">重置</el-button>
          <el-button class="cancel" icon="el-icon-close" @click="dialogVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 引入API
import { updatePasswordAPI } from "@/api/userApi";
import { encryptAES, validatePasswordComplexity } from "@/utils/aes";
import { Message } from "element-ui";
import { NarBar, SiderBar, AppMain } from "./components";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "LayOut",
  data() {
    const validatePass1 = (rule, value, callback) => {
      // ✅ 已启用密码复杂度强制验证
      const validation = validatePasswordComplexity(value);
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (!validation.valid) {
        callback(new Error(validation.message));
        return;
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      form: {
        oldPassword: "",
        password: "",
        checkPassword: "",
      },
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass1, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //
    handleClickItem(item) {
      if (item === 1) {
        this.dialogVisible = true;
      } else if (item === 2) {
        this.goBack();
      }
    },
    // 退出登录
    goBack() {
      this.$store.commit("user/clearToken");
      this.$store.commit("user/clearsetuserInfo");

      this.$router.push("/login");
    },
    submitForm() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          // AES加密密码后再传输
          const oldPassword = encryptAES(this.form.oldPassword);
          const newPassword = encryptAES(this.form.checkPassword);

          const Data = {
            oldPassword: oldPassword,
            newPassword: newPassword,
          };

          const res = await updatePasswordAPI(this.$store.state.user.userInfo.id, Data);

          if (res.code === 200) {
            Message.success(res.data);
            this.dialogVisible = false;

            this.$router.push("/login");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.passwordForm.resetFields();
    },
  },
  computed: {
    URL() {
      return this.$route.path.split("/")[2];
    },
    userName() {
      return this.$store.state.user.userInfo.username;
    },
  },
  components: {
    AppMain,
    NarBar,
    SiderBar,
  },
};
</script>

<style lang="scss" scoped>
.app-warpper {
  display: flex;
  flex-direction: column;

  .header {
    z-index: 5;
    display: flex;
    justify-content: space-between;
    height: vw(80);
    line-height: vw(80);
    padding: 0 vw(30);
    background-color: #2851cd;
    color: #fff;
    box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.6);
    .bigtitle {
      font-size: vw(26);
      .logo {
        float: left;
        margin-right: vw(20);
        width: vw(120);
        height: vw(80);
        background-image: url(@/assets/sys/logo.png);
        background-size: 150% 180%;
        background-position: center;
      }
    }
    .right {
      display: flex;
      a {
        color: #fff;
      }

      .line {
        width: vw(1);
        height: vw(30);
        margin: vw(25) vw(20);
        background-color: black;
      }

      .user {
        display: flex;
        position: relative;
        .pic {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: vw(40);
          height: vw(40);
          background-color: #fff;
          border-radius: 50%;
        }

        .name {
          margin-left: vw(60);
          font-weight: bold;

          .el-dropdown-link {
            cursor: pointer;
            color: #fff;
            font-size: vw(16);
          }
          .el-icon-arrow-down {
            font-size: 12px;
          }
        }
      }
    }
  }

  .main-container {
    height: calc(100vh - vw(80));
    display: flex;
    background-color: #eee;

    .siderbar {
      width: vw(260);
      height: 100%;
      background-color: #fff;
    }

    .appMain {
      flex: 1;
      display: flex;
      min-width: 0;
      overflow: hidden;
      background-color: transparent;
    }
  }
}

::v-deep .el-dialog {
  flex-direction: column;
  padding: 0 0 20px 0;
  .el-dialog__header {
    padding: vw(15) vw(25);
    background-color: #2851cd;
    .el-dialog__title {
      color: #fff;
      font-size: vw(20);
      font-weight: bold;
    }
    .el-dialog__headerbtn {
      top: vw(20);
      .el-dialog__close {
        font-size: vw(20);
        color: #f3f6fa;
      }
    }
  }

  .el-dialog__body {
    flex-grow: 1;
    padding: 20px 20px;

    .note {
      font-size: vw(14);
      color: red;
      margin-bottom: 20px;
    }

    .footer {
      position: relative;
      flex: 1;
      margin-top: 20px;
      .footer-button {
        width: 100%;
        text-align: center;

        .el-button {
          padding: vw(10) vw(40);
        }

        .submit {
          background-color: #1576e2;
        }
        .cancel {
          background-color: #dbdee4;
          color: #818e9b;
        }
      }
    }
  }
}
</style>
